import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';
import globalData from '@/store/globalData';
import { EndpointError } from '@/services/errorService';

export const ENDPOINTS = deepFreeze({
    PUBLISHERS: {
        URI: () => '/api/v1/publishers/{{id}}/buyboxes',
        methods: ['get'],
        default: [],
        formatter: data => data?.items,
    },
    BUYBOXES: {
        URI: () => '/api/v1/buyboxes/{{id?}}',
        methods: ['get', 'delete', 'patch'],
        default: [],
        cacheToClear: ['/api/v1/buyboxes', '/api/v1/publishers/\\d+/buyboxes', '/api/v1/spaces/\\d+/buyboxes'],
    },
    SPACES: {
        URI: () => '/api/v1/spaces/{{id}}/buyboxes',
        methods: ['get', 'post'],
        default: [],
        cacheToClear: ['/api/v1/buyboxes', '/api/v1/publishers/\\d+/buyboxes', '/api/v1/spaces/\\d+/buyboxes'],
    },
    LANDING_PAGES: {
        URI: () => '/api/v1/publishers/{{id}}/buybox-landing-pages',
        methods: ['get'],
        default: {},
        formatter: data => data?.items || [],
    },
    CAMPAIGNS: {
        URI: () => '/api/v1/buyboxes/{{id}}/campaigns/{{campaignId?}}',
        methods: ['delete', 'patch', 'post'],
        default: [],
        cacheToClear: ['/api/v1/publishers/{{id}}/buyboxes/campaigns', '/api/v1/buyboxes/{{id}}/campaigns', '/api/v1/buyboxes/{{id}}/campaigns-available', '/api/v1/buyboxes/{{id}}/campaigns-available-for-producer'],
    },
    ACTIVE_CAMPAIGNS: {
        URI: () => '/api/v1/buyboxes/{{id}}/campaigns',
        methods: ['get'],
        default: [],
        formatter: data => (data?.items || data || []).map(item => ({ ...item.campaign, priority: item.priority })),
    },
    AVAILABLE_CAMPAIGNS: {
        URI: () => {
            if (globalData.user.isRoleWidgeter) return '/api/v1/buyboxes/{{id}}/campaigns-available';
            if (globalData.user.isRoleProducer) return '/api/v1/buyboxes/{{id}}/campaigns-available-for-producer';
            throw new EndpointError();
        },
        methods: ['get'],
        default: [],
        formatter: data => (Array.isArray(data?.items || data) ? data?.items || data : Object.values(data?.items || data || {})),
    },
    BUYBOX_SORT_TYPES: {
        URI: () => '/api/v1/buybox-sort-types',
        methods: ['get'],
        default: [],
    },
    WIDGET_VERSIONS: {
        URI: () => '/api/v1/widget-versions',
        methods: ['get'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
